<div class="row d-flex justify-content-center my-10" *ngIf="studyMethods.length > 0">
    <div class="col-12 col-sm-10 col-md-6">
        <ul class="nav nav-pills nav-fill nav-pay-method">
            <li class="nav-item cursor-pointer">
                <span class="nav-link" [class.active]="payMethod == 'once-off'"
                    (click)="payMethod = 'once-off'">Once-Off Pricing</span>
            </li>
            <li class="nav-item cursor-pointer">
                <span class="nav-link" [class.active]="payMethod == 'monthly'" (click)="payMethod = 'monthly'">Monthly
                    Pricing</span>
            </li>
        </ul>
    </div>
</div>
<div class="row d-flex justify-content-center">
    <ng-container *ngFor="let studyMethod of studyMethods">
        <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl study-method mb-10">

            <img loading="lazy" *ngIf="studyMethod.title == 'Campus Classes'" src="assets/img/study-methods/icn-classes.webp"
                class="img-fluid d-block mx-auto" style="max-height: 72px; position: relative; z-index: 1;" />

            <img loading="lazy" *ngIf="studyMethod.title == ''" src="assets/img/study-methods/icn-exam-prep.webp"
                class="img-fluid d-block mx-auto" style="max-height: 72px; position: relative; z-index: 1;" />

            <img loading="lazy" *ngIf="studyMethod.title.includes('Home Study')" src="assets/img/study-methods/icn-home-study.webp"
                class="img-fluid d-block mx-auto" style="max-height: 72px; position: relative; z-index: 1;" />

            <img loading="lazy" *ngIf="studyMethod.title == ''" src="assets/img/study-methods/icn-masterclasses.webp"
                class="img-fluid d-block mx-auto" style="max-height: 72px; position: relative; z-index: 1;" />

            <img loading="lazy" *ngIf="studyMethod.title == 'Online Classroom (OCR)'
                        || studyMethod.title == 'Online Clasroom' 
                        || studyMethod.title == 'Virtual Classes' 
                        || studyMethod.title == 'Virtual Classes (Global)'"
                src="assets/img/study-methods/icn-online-classes.webp" class="img-fluid d-block mx-auto"
                style="max-height: 72px; position: relative; z-index: 1;" />

            <div class="card pricing-block shadow-xs rounded text-center" style="margin-top: -12px;">
                <div class="card-body">
                    <h6 class="font-weight-bold font-size-16" style="height: 40px; overflow: hidden;">{{
                        studyMethod.title }}</h6>
                    <p class="font-size-14">{{ studyMethod?.pricing?.length }} Classes</p>
                    <p class="mb-0">
                        <a [routerLink]="['/courses', institution?.slug, 'all']" [queryParams]="{'study-method': studyMethod.slug}">


                            <button *ngIf="payMethod == 'once-off' && studyMethod?.pricing?.length" type="button"
                                class="btn btn-primary btn-block font-size-16 font-weight-bold frm-text">From <span
                                    class="hide-mobile"><br /></span>R{{
                                studyMethod?.pricing[0]['once-off'] | number : '1.0-0' }}
                            </button>
                            <button *ngIf="payMethod == 'monthly' && studyMethod?.pricing?.length" type="button"
                                class="btn btn-primary btn-block font-size-16 font-weight-bold frm-text">From <span
                                    class="hide-mobile"><br /></span>R{{
                                studyMethod?.pricing[0]['monthly'] | number : '1.0-0' }}
                            </button>
                        </a>
                    </p>
                </div>
            </div>
        </div>
    </ng-container>
</div>